module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_6_B_1.ea606e43.mp3";